import React from "react"
// import React, { useState, useEffect } from "react";
// import Chart from "react-apexcharts";
// import axios from 'axios'
// import { CSVLink } from "react-csv";
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';

function Top() {


    // Today

    // let idSum = 0;

    // let idSumTodayQty = 0;
    // let idSumYes = 0;
    // let idSumYesQty = 0;
    // let idSumMon = 0;
    // let idSumMonQty = 0;
    // let idSumpreMon = 0;
    // let idSumpreMonQty = 0;

    // for (let i = 0; items && i < items.length; i++) {
    //     idSum += items[i].today;
    //     idSumTodayQty += items[i].todayQty;
    //     idSumYes += items[i].yesterday;
    //     idSumYesQty += items[i].yesterdayQty;
    //     idSumMon += items[i].monthly;
    //     idSumMonQty += items[i].monthlyQty;
    //     idSumpreMon += items[i].previous;
    //     idSumpreMonQty += items[i].previousQty;
    // }


    return (
        <>
            <h4>Top 10 Design Summary</h4>

        </>
    )
}

export default Top